/* ============================================
   FOURNIDOO THEME — JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ======= MOBILE MENU =======
  const mobileToggle = document.querySelector('.js-mobile-menu');
  const mobileNav = document.querySelector('.js-mobile-nav');
  const mobileNavClose = document.querySelector('.js-mobile-nav-close');
  const mobileNavOverlay = document.querySelector('.js-mobile-nav-overlay');

  function openMobileNav() {
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (mobileNavOverlay) mobileNavOverlay.classList.add('is-visible');
    mobileToggle.setAttribute('aria-expanded', 'true');
    mobileToggle.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (!mobileNav || !mobileToggle) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (mobileNavOverlay) mobileNavOverlay.classList.remove('is-visible');
    mobileToggle.setAttribute('aria-expanded', 'false');
    mobileToggle.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      if (mobileNav.classList.contains('is-open')) closeMobileNav();
      else openMobileNav();
    });
  }

  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);

  // ======= CART DRAWER =======
  const cartTriggers = document.querySelectorAll('.js-cart-trigger');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartClose = cartDrawer ? cartDrawer.querySelector('.cart-drawer__close') : null;
  const cartOverlay = cartDrawer ? cartDrawer.querySelector('.cart-drawer__overlay') : null;

  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.add('is-open');
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  cartTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', openCartDrawer);
  });

  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  // ======= ADD TO CART =======
  function showCartNotification() {
    const notification = document.getElementById('cart-notification');
    if (!notification) return;
    notification.style.display = 'flex';
    setTimeout(function () { notification.style.display = 'none'; }, 2500);
  }

  function updateCartCount(count) {
    document.querySelectorAll('.js-cart-count').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        var totalEl = document.getElementById('cart-total');
        if (totalEl) {
          totalEl.textContent = formatMoney(cart.total_price);
        }
      })
      .catch(function () {});
    // Recharge la liste des articles (rendu serveur via la vue "drawer")
    fetch('/cart?view=drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var content = document.getElementById('cart-drawer-content');
        if (content) content.innerHTML = html;
      })
      .catch(function () {});
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // Add-to-cart buttons (product page form)
  document.querySelectorAll('.js-add-to-cart').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const form = btn.closest('form');
      if (!form) return;

      const variantId = form.querySelector('[name="id"]').value;
      const quantity = form.querySelector('[name="quantity"]') ? parseInt(form.querySelector('[name="quantity"]').value, 10) : 1;

      btn.disabled = true;
      btn.textContent = 'Ajout en cours...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
        .then(function (r) { if (!r.ok) { throw new Error('cart'); } return r.json(); })
        .then(function () {
          btn.textContent = 'Ajouté au panier !';
          showCartNotification();
          refreshCartDrawer();
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = 'Ajouter au panier';
            openCartDrawer();
          }, 1000);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Stock insuffisant';
          setTimeout(function () { btn.textContent = 'Ajouter au panier'; }, 2500);
        });
    });
  });

  // Quick add from product cards
  document.querySelectorAll('.product-card__quick-add').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const productId = btn.dataset.productId;
      if (!productId) return;

      btn.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: productId, quantity: 1 })
      })
        .then(function (r) { if (!r.ok) { throw new Error('cart'); } return r.json(); })
        .then(function () {
          btn.textContent = 'Ajouté !';
          showCartNotification();
          refreshCartDrawer();
          setTimeout(function () { btn.textContent = 'Ajouter au panier'; }, 1500);
        })
        .catch(function () {
          btn.textContent = 'Stock insuffisant';
          setTimeout(function () { btn.textContent = 'Ajouter au panier'; }, 2500);
        });
    });
  });

  // ======= QUANTITY BUTTONS (délégation : survit au re-render du drawer) =======
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-minus, .qty-plus');
    if (!btn) return;
    var isMinus = btn.classList.contains('qty-minus');
    var key = btn.dataset.key;

    // Panier (page ou drawer) : mise à jour AJAX
    if (key) {
      var qtyEl = btn.parentElement.querySelector('.cart-item__qty-value') ||
        btn.parentElement.querySelector('span');
      var currentQty = parseInt(qtyEl ? qtyEl.textContent : 1, 10);
      var newQty = isMinus ? Math.max(0, currentQty - 1) : currentQty + 1;
      var inDrawer = !!btn.closest('#cart-drawer');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
        .then(function (r) { if (!r.ok) { throw new Error('cart'); } return r.json(); })
        .then(function () {
          if (inDrawer) { refreshCartDrawer(); }
          else { location.reload(); }
        })
        .catch(function () {});
      return;
    }

    // Page produit : compteur local
    var input = btn.parentElement.querySelector('.qty-input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    if (isMinus) val = Math.max(1, val - 1);
    else val = Math.min(99, val + 1);
    input.value = val;
  });

  // Suppression d'un article (délégation)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-item__remove');
    if (!btn || !btn.dataset.key) return;
    var inDrawer = !!btn.closest('#cart-drawer');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
    })
      .then(function (r) { if (!r.ok) { throw new Error('cart'); } })
      .then(function () {
        if (inDrawer) { refreshCartDrawer(); }
        else { location.reload(); }
      })
      .catch(function () {});
  });


  // ======= RÉVÉLATIONS AU SCROLL =======
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var revealEls = document.querySelectorAll('.cat-card, .product-card, .trust-item, .testimonial-card, .section__header, .assoc-banner__inner, .newsletter__inner, .about-hero__content, .assoc-page-hero__inner');
    revealEls.forEach(function (el, i) {
      el.classList.add('reveal');
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    document.documentElement.classList.add('no-reveal');
  }

  // ======= PRODUCT GALLERY =======
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.getElementById('main-product-image');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImg) mainImg.src = thumb.dataset.image;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // ======= VARIANT SELECTION =======
  // Résout la variante réelle à partir des options cliquées et met à jour #variant-id
  var variantsEl = document.getElementById('product-variants-json');
  var productVariants = null;
  if (variantsEl) {
    try { productVariants = JSON.parse(variantsEl.textContent); } catch (err) { productVariants = null; }
  }

  function syncSelectedVariant() {
    if (!productVariants) return;
    var selected = [];
    document.querySelectorAll('.product-option__values').forEach(function (group) {
      var btn = group.querySelector('.option-btn.is-selected');
      if (btn) selected.push(btn.dataset.value);
    });
    if (!selected.length) return;
    var match = productVariants.find(function (v) {
      return selected.every(function (val, i) { return v.options[i] === val; });
    });
    var idInput = document.getElementById('variant-id');
    var addBtn = document.querySelector('.js-add-to-cart');
    if (match && idInput) {
      idInput.value = match.id;
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Ajouter au panier' : 'Rupture de stock';
      }
      var priceEl = document.querySelector('.price-current');
      if (priceEl && typeof match.price === 'number') priceEl.textContent = formatMoney(match.price);
    } else if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = 'Combinaison indisponible';
    }
  }

  document.querySelectorAll('.option-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.product-option__values');
      if (group) {
        group.querySelectorAll('.option-btn').forEach(function (b) { b.classList.remove('is-selected'); });
      }
      btn.classList.add('is-selected');
      syncSelectedVariant();
    });
  });

  // ======= SMOOTH SCROLL FOR ANCHOR LINKS =======
  document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach(function (link) {
    link.addEventListener('click', function (e) {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
